import {AfterViewInit, Injectable, OnInit} from '@angular/core';
import {BehaviorSubject, delay, Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  counter = 0;

  public status: Subject<boolean> = new BehaviorSubject(false);
  public status$: Observable<boolean> = this.status.asObservable().pipe(delay(0));
  caption: any;
  constructor() { }

  show(spinnerMsg: any = 'Loading..'){
    this.caption = spinnerMsg;
    this.status.next(true);
  }

  hide() {
    this.status.next(false);
  }

  spinnerObservable() {
    return this.status$;
  }
}
